import { Stack } from '@mui/material';
import { Cell, Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ColorCircle } from './ColorCircle';
import { LiquidGlassRowCard } from './LiquidGlassRowCard';

interface ColorPickerProps {
  selectedColor: string;
  onClick: () => void;
}

export const ColorPicker: FC<ColorPickerProps> = ({ selectedColor, onClick }) => {
  const { t } = useTranslation();

  return (
    <LiquidGlassRowCard>
      <Cell
        onClick={onClick}
        after={
          <ColorCircle
            code={selectedColor}
            selected={false}
            onSelect={() => {}}
            sx={{ cursor: 'pointer' }}
          />
        }
      >
        <Stack direction="column" gap={0.1}>
          <Text weight="2">{t('picker.color')}</Text>
          <Text style={{ fontSize: '12px', color: 'var(--tgui--hint_color)' }}>
            {t('picker.chooseColor')}
          </Text>
        </Stack>
      </Cell>
    </LiquidGlassRowCard>
  );
};
